import { render, staticRenderFns } from "./FlowView.vue?vue&type=template&id=83084d96&scoped=true&"
import script from "./FlowView.vue?vue&type=script&lang=js&"
export * from "./FlowView.vue?vue&type=script&lang=js&"
import style0 from "./FlowView.vue?vue&type=style&index=0&id=83084d96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83084d96",
  null
  
)

export default component.exports